import { render, staticRenderFns } from "./accept_terms_page.vue?vue&type=template&id=647471ee"
import script from "./accept_terms_page.vue?vue&type=script&lang=js"
export * from "./accept_terms_page.vue?vue&type=script&lang=js"
import style0 from "./accept_terms_page.vue?vue&type=style&index=0&id=647471ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports